import React, {Component, useRef} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import EditInput from "../../../etc/admin/input"

import * as func from "../../../../utils/functions";

import * as Actions from "../../../../store/modules/journals";
import * as FActions from "../../../../store/modules/footer";

import InputBox from "../../../etc/InputBox"

import {PropTypes} from "prop-types";
import JournalItem from "../../front/list/Jitem";
import TopNav from "../../../admin/etc/tab";
import {getParams, pushUrl} from "../../../../utils/functions";
import JournalForm from "./0_defaultForm";
// import Ids from "./1_Ids";
import Categories from "./2_categories";
import Relation from "./3_relation";
import Indicator from "./4_pieces/";
import MetaForm from "./0_metaForm/";

const arr = ["기본정보", "등재·카테고리", "Indicator 정보", "저널 연결", "메타 정보"];
// , "변경 이력"
const arr2 = ["기본정보"];
const vObj = {
	0: <JournalForm/>,
	1: <Categories/>,
	2: <Indicator/>,
	3: <Relation/>,
	// 4: <JournalMeta/>,
	4: <MetaForm/>,
	// 5: <Temp4/>,
	// 6: <Temp5/>,
	// 7: <Temp6/>,
}

class JAContent extends Component {
	constructor(props) {
		super(props);

		const activeTabID = getParams('tab_id') ? getParams('tab_id') : 0;

		this.state = {
			activeTab: activeTabID === null ? 0 : activeTabID,
			isInit: false
		};

		this.showHide = this.showHide.bind(this)
	}

	componentDidMount() {
		if (func.getParams("record_id")) {
			func.getData("admin/journal/" + func.getParams("record_id"), null).then((response) => {

				if (response.record) {
					this.props.dataActions.setJournal(response)
				} else if(response.code === "fail") {
					alert(response.message)
					window.location.href = 'admin.php?page=journal';
				}

				if (!this.state.isInit) {
					this.setState({
						isInit: true,
					})
				}
			});
		} else if (!this.state.isInit) {
			this.setState({
				isInit: true,
			})
		}
	}

	updateValue = (id) => {
		this.setState({
			activeTab: id
		});

		const url = func.changeParamUrl('tab_id', id)

		pushUrl('탭', url, null);
	}

	showHide () {
		let status = this.props.showSide === 'true' ? 'false' : 'true'
		func.setCookie('side', status, 999)
		this.props.dataActions.setJournal({'showSide' : status});
	}

	render() {
		return (
			<div className="col pl-0 detail journal-detail">
				{this.state.isInit &&
				<>
					<div className="detail-tabs">
						<TopNav
							tabList={this.props.record.journal_id ? arr : arr2}
							changeTab={this.updateValue}
							activeID={this.state.activeTab}
						/>
						{this.props.showSide !== 'false' &&
						<span className="hide-side-list full-screen-icon" onClick={this.showHide}/>
						}
						{this.props.showSide === 'false' &&
						<span className="view-side-list list-icon" onClick={this.showHide}/>
						}
					</div>
					<div className="detail-content">
						{vObj[this.state.activeTab]}
					</div>
				</>
				}
			</div>
		)
	}
}

export default connect(
	(state) => ({
		record: state.journals.record ? state.journals.record : {},
		showSide : state.journals.showSide ? state.journals.showSide  : 'true'
		// meta: state.journals.meta ? state.journals.meta : {},
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch),
		// fDataActions: bindActionCreators(FActions, dispatch)
	}),
)(JAContent)

JAContent.propTypes = {
	// args : PropTypes.object,
	// facet : PropTypes.object,
};


// DefaultForm.propTypes = {
//   args: PropTypes.object,
//   facet: PropTypes.object,
// };
